import { render } from "./EconomicLoader.vue?vue&type=template&id=62e6644c&scoped=true&ts=true"
import script from "./EconomicLoader.vue?vue&type=script&lang=ts"
export * from "./EconomicLoader.vue?vue&type=script&lang=ts"

import "./EconomicLoader.vue?vue&type=style&index=0&id=62e6644c&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\selecta\\selectashopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e6644c"]])

export default __exports__